import React from "react";
import RadioButtonQuest from '../../../UI/RadioButtonQuest';
import GtmDataLayer from "../../../../Utility/GtmDataLayer";

const InitiallyTaken = ({ clsName, onSelectAnswer, backClick, setBckFrmQ108 }) => {

    const optionHandle = async (e) => {
        setBckFrmQ108(e.target.value);
        onSelectAnswer(e);
    }

    return (
        <>
            <div className={`qsSlider slidea1 ${clsName}`}>
                <h2 className="qs-title slide-up-now">
                    Was your overdraft initially taken out more than six years ago?
                </h2>
                <div className="btn-option optinal-items singleqs slide-up-now">
                    <div className=" option_but mb-3">
                        <RadioButtonQuest
                            key="it1"
                            className="radio"
                            labelName="Yes"
                            onClick={optionHandle}
                            value="379"
                            name="initiallytaken"
                            id="it1"
                            dataQuestId={123}
                            dataAnsId={379}
                            dataAnsLabel="Yes"
                        />
                    </div>
                    <div className=" option_but  mb-3">
                        <RadioButtonQuest
                            key="it2"
                            className="radio"
                            labelName="No"
                            onClick={optionHandle}
                            value="380"
                            name="initiallytaken"
                            id="it2"
                            dataQuestId={123}
                            dataAnsId={380}
                            dataAnsLabel="No"
                        />
                    </div>
                </div>
                <div className="mt-2 mb-5 text-center">
                    <div>
                        {" "}
                        <button type="button" className="back-btn mainbckBtn bi bi-chevron-left" id="back02" name="closedyear" onClick={backClick}>
                            Back
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InitiallyTaken;
